/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_SuggestedInputs */

const vi_einvoice_suggested = /** @type {(inputs: Einvoice_SuggestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gợi ý, bạn có thể sửa`)
};

/**

* @param {Einvoice_SuggestedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_suggested = /** @type {((inputs?: Einvoice_SuggestedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_SuggestedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_suggested(inputs)
});